export const CHECKOUT_URL = "https://pay.monetizze.com.br/KPC469793";

export const PRICE_OLD = "R$ 97";
export const PRICE_NEW = "R$ 16,97";

export const scrollToId = (selector) => {
  const el = document.querySelector(selector);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
